const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
  content: [
    './src/**/*.{jsx,tsx}',
    './node_modules/@grace-studio/graceful-next/src/**/*.tsx',
    './node_modules/@grace-studio/graceful-next/lib/**/*.tsx',
  ],
  safelist: ['custom-tooltip', 'custom-tooltip__content', 'animate-ping'],
  theme: {
    extend: {
      fontFamily: {
        sans: ['Source Sans Pro', ...defaultTheme.fontFamily.sans],
        serif: ['Merriweather', ...defaultTheme.fontFamily.serif],
      },
      fontSize: {
        sm: '16px',
        medium: ['1rem', '2em'],
        medium2: ['1.025rem', '2em'],
        large: ['1.25rem', '1.5em'],
        xlarge: ['2.5rem', '1.25em'],
        huge: ['5rem', '1.25em'],
      },
      colors: {
        blue: '#003E89',
        white: '#ffffff',
        disabled: '#B1B7C2',
        focus: '#dd821c',
        'complementary-1': '#B4C6CF',
        'complementary-7': '#F4F1EF',
        'grey-900': '#000000',
        'grey-800': '#162644',
        'grey-700': '#3C4B66',
        'grey-500': '#7F899D',
        'grey-400': '#AFB6C4',
        'grey-200': '#E2E5EB',
        'grey-50': '#F7F8F9',
        'financial-1': '#B9BDCA',
        'financial-2': '#A5AAB8',
        'financial-3': '#8B94A8',
        'financial-4': '#435670',
        'financial-5': '#132B4D',
        'human-1': '#C5C6B4',
        'human-2': '#B0B5AA',
        'human-3': '#9EA895',
        'human-4': '#6B7662',
        'human-5': '#254445',
        'sustainability-1': '#DCD7CB',
        'sustainability-2': '#D5C7BE',
        'sustainability-3': '#C2B3A3',
        'sustainability-4': '#C8A38D',
        'sustainability-5': '#886B67',
      },
      width: {
        sidebar: '22rem',
        'sidebar-small': '16rem',
        onboarding: '24rem',
      },
      maxWidth: {
        medium: '32rem',
      },
      screens: {
        betterhover: { raw: '(hover: hover)' },
        ipadportait: '820px',
        supported: '500px',
      },
      transitionTimingFunction: {
        bounce: 'cubic-bezier(0.29, 1.34, 0.49, 1)',
      },
      animation: {
        'bounce-sideways-l': 'bounceSidewaysL 1s ease infinite',
        'bounce-sideways-r': 'bounceSidewaysR 1s ease infinite',
      },
      keyframes: {
        loading1: {
          '0%': { opacity: 0, transform: 'translateY(-40px)' },
          '12.5%, 50%': { opacity: 1, transform: 'translateY(0)' },
          '75%, 100%': { opacity: 0 },
        },
        loading2: {
          '0%, 12.5%': { opacity: 0, transform: 'translateX(40px)' },
          '25%, 50%': { opacity: 1, transform: 'translateY(0)' },
          '75%, 100%': { opacity: 0 },
        },
        loading3: {
          '0%, 25%': { opacity: 0, transform: 'translateX(-40px)' },
          '37.5%, 50%': { opacity: 1, transform: 'translateY(0)' },
          '75%, 100%': { opacity: 0 },
        },
        loading4: {
          '0%, 37.5%': { opacity: 0, transform: 'translateY(40px)' },
          '50%': { opacity: 1, transform: 'translateY(0)' },
          '75%, 100%': { opacity: 0 },
        },
        bounceSidewaysL: {
          '0%, 100%': {
            transform: 'translateX(-5px)',
            'animation-timing-function': 'cubic-bezier(0.8, 0, 1, 1)',
          },
          '50%': {
            transform: 'translateX(0px)',
            'animation-timing-function': 'cubic-bezier(0, 0, 0.2, 1)',
          },
        },
        bounceSidewaysR: {
          '0%, 100%': {
            transform: 'translateX(5px)',
            'animation-timing-function': 'cubic-bezier(0.8, 0, 1, 1)',
          },
          '50%': {
            transform: 'translateX(0px)',
            'animation-timing-function': 'cubic-bezier(0, 0, 0.2, 1)',
          },
        },
      },
    },
  },
  plugins: [],
};
